import {AbstractModel} from '../../abstract-model';
import {StaticPage} from '../static-page';
import {FunnelLink} from './funnel-link';
import {FunnelPageType} from '../../../constants/funnel-page-type';

export class FunnelPage extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  slug: string | null = null;
  type: FunnelPageType = FunnelPageType.URL;
  staticPage: StaticPage | null = null;
  url: string | null = null;
  links: FunnelLink[] = [];
  positionX: number | null = null;
  positionY: number | null = null;
  options: any = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.staticPage) {
      this.staticPage = new StaticPage().deserialize(input.staticPage);
    }

    if (input.links) {
      this.links = input.links.map((link: any) => new FunnelLink().deserialize(link));
    }

    return this;
  }

  override toString(): string {
    return this.name ?? '';
  }
}
